<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">修改手机/邮箱</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">登录ID</div>
                <div class="item-input">
                  <input type="text" v-model.trim.trim="account" placeholder="登录手机号或邮箱">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input" style="display: inline">
                  <input style="width:6rem;display: inline;" type="text" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">登录密码</div>
                <div class="item-input">
                  <input type="password" v-model.trim="password" placeholder="登录密码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">新登录ID</div>
                <div class="item-input">
                  <input type="text" v-model.trim="newLoginId" placeholder="新ID">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">确认新ID</div>
                <div class="item-input">
                  <input type="text" v-model.trim="newLoginIdRe" placeholder="确认新ID">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-50">
            <router-link :to="{ name: 'me' }" class="button button-big button-fill button-danger">取消</router-link>
          </div>
          <div class="col-50"><a @click="submit" class="button button-big button-fill button-success">确认</a></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import md5 from 'js-md5'
  import {mapMutations} from 'vuex'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        account: '',
        password: '',
        veriCode: '',
        coolDown: false,
        newLoginId: '',
        newLoginIdRe: '',
        error: ''
      }
    },
    methods: {
      ...mapMutations([
        'LOGIN_STATE_UPDATE'
      ]),
      sendVeriCode () {
        let _this = this
        if (!_this.coolDown) {
          _this.gcapi('gcwwwifc/requestChangeLoginID', {
            'ExLoginId': _this.account,
            'NewLoginId': _this.newLoginId,
            'Password': md5(_this.password).toUpperCase()
          }).then((response) => {
            _this.coolDown = true
            time(document.getElementById('btn'))
            $.toast(response.body['message'])
          }, (response) => {
            $.toast(response.body['message'])
          })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      checkNewLoginId () {
        var _this = this
        if (_this.veriCode === '') {
          _this.error = '请输入验证码'
          return false
        }
        if (!_this.newLoginId === _this.newLoginId) {
          _this.error = '两次输入不相同'
          return false
        }
        if (_this.newLoginId === _this.account) {
          _this.error = '新ID与原ID相同'
          return false
        }
        return true
      },
      submit () {
        let _this = this
        if (_this.checkNewLoginId()) {
          _this.gcapi('gcwwwifc/changeLoginID', {
            'LoginId': _this.newLoginId,
            'VerifyCode': _this.veriCode
          }).then((response) => {
            if (response.body.code === 0) {
              $.toast(response.body['message'])
              _this.gcapi('gcwwwifc/userLogout')
              _this.LOGIN_STATE_UPDATE(false)
              _this.$router.push('/login')
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
        } else {
          $.toast(_this.error)
        }
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// ChangeLoginID.vue?32c0fb2c